export default "__VITE_ASSET__B98RX2ZL__"